import { Component, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import anime from 'animejs/lib/anime.es.js';

@Component({
  selector: 'app-typing-dots',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg width="24" height="24" viewBox="0 0 24 24">
      <circle cx="4" cy="12" r="2" fill="#666" />
      <circle cx="12" cy="12" r="2" fill="#666" />
      <circle cx="20" cy="12" r="2" fill="#666" />
    </svg>
  `,
  styles: [`
    :host {
      display: inline-block;
    }
    svg {
      vertical-align: middle;
    }
  `]
})
export class TypingDotsComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    this.animateDots();
  }

  private animateDots(): void {
    anime({
      targets: 'circle',
      translateY: [
        { value: -4, duration: 400 },
        { value: 0, duration: 400 }
      ],
      easing: 'easeInOutQuad',
      delay: anime.stagger(200), // Stagger each dot by 200ms
      loop: true,
      direction: 'alternate'
    });
  }
}